import { render, staticRenderFns } from "./morningPaperIndex.vue?vue&type=template&id=c1ad0584&scoped=true&"
import script from "./morningPaperIndex.vue?vue&type=script&lang=js&"
export * from "./morningPaperIndex.vue?vue&type=script&lang=js&"
import style0 from "./morningPaperIndex.vue?vue&type=style&index=0&id=c1ad0584&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ad0584",
  null
  
)

export default component.exports